import { useState, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';

interface AdminLayoutProps {
  children: React.ReactNode;
  pageTitle: string;
  activeKey: string;
}

export default function AdminLayout({ children, pageTitle, activeKey }: AdminLayoutProps) {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleMenuClick = useCallback((path: string) => navigate(path), [navigate]);

  return (
    <div className="min-h-screen bg-[#f6f9fa]">
      <Sidebar
        collapsed={collapsed}
        activeKey={location.pathname || activeKey}
        onMenuClick={handleMenuClick}
      />
      <Header collapsed={collapsed} onCollapse={setCollapsed} pageTitle={pageTitle} />
      <main
        className="pt-14 transition-all duration-300 min-h-screen"
        style={{ marginLeft: collapsed ? 64 : 240 }}
      >
        <div className="p-6">{children}</div>
      </main>
    </div>
  );
}
